import { useState, useEffect } from "react";
import "../../Complaint.css";
import "bootstrap/dist/css/bootstrap.min.css";
import CommonContainer from "../Container/CommonContainer";
import toast from "react-hot-toast";
import "react-datepicker/dist/react-datepicker.css";
import { FaSearch, FaSpinner, FaToggleOff, FaToggleOn, FaTrash } from "react-icons/fa";
import CommonPagination from "../../Common/CommonPagination";
import RoleUserAccessMappingModal from "./RoleUserAccessMappingModal";
import * as UserService from "../../Services/User/UserService";

const RoleUserAccessMappingComponent = () => {
  const [roleUserAccessMappingList, setRoleUserAccessMappingList] = useState(
    [],
  );

  const [searchLoading, setSearchLoading] = useState(false);
  const [searchData, setSearchData] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [activeRoleList, setActiveRoleList] = useState([]);
  const [accessControlList, setAccessControlList] = useState([]);

  // Pagination states
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);

  const filteredRoleUserAccessMappingList = roleUserAccessMappingList.filter(
    (rec) => {
      const searchLower = searchData.toLowerCase();

      return (
        rec.Role_Id?.toString().toLowerCase().includes(searchLower) ||
        rec.Role_Name?.toLowerCase().includes(searchLower) ||
        rec.Access_Control_Id?.toString().toLowerCase().includes(searchLower) ||
        rec.Access_Control_Name?.toLowerCase().includes(searchLower)
      );
    },
  );

  // const filteredOrganizationMasterList = organizationMasterList
  //   .filter((rec) => {
  //     const searchLower = searchData.toLowerCase();

  //     return (
  //       rec.OrgLocationId?.toString().toLowerCase().includes(searchLower) ||
  //       rec.OrgLocationName?.toLowerCase().includes(searchLower) ||
  //       rec.OrganizationId?.toString().toLowerCase().includes(searchLower) ||
  //       rec.OrganizationName?.toLowerCase().includes(searchLower)
  //     );
  //   })
  //   .sort((a, b) => {
  //     const aVal = a.Is_Processing_Location ? 1 : 0;
  //     const bVal = b.Is_Processing_Location ? 1 : 0;

  //     return processingSortOrder === "asc" ? aVal - bVal : bVal - aVal;
  //   });

  // Pagination logic
  const indexOfLastOrg = currentPage * itemsPerPage;
  const indexOfFirstOrg = indexOfLastOrg - itemsPerPage;
  const currentRoleUserAccessMappingList =
    filteredRoleUserAccessMappingList.slice(indexOfFirstOrg, indexOfLastOrg);

  useEffect(() => {
    setCurrentPage(1);
  }, [searchData]);

  useEffect(() => {
    fetchUniversalRoleUserAccessMasterList();
  }, []);

  const fetchUniversalRoleUserAccessMasterList = () => {
    setSearchLoading(true);

    UserService.GetUniversalRoleAccessMapping()
      .then(({ data }) => {
        if (data.IsSuccess) {
          setRoleUserAccessMappingList(data.Data);
        } else {
          setRoleUserAccessMappingList([]);
        }
      })
      .catch(() => toast.error("Something went wrong"))
      .finally(() => {
        setSearchLoading(false);
      });
  };

  const GetRoleList = () => {
    UserService.GetUserDependedFeildDataList()
      .then(({ data }) => {
        if (data.IsSuccess) {
          setActiveRoleList(data.Data.RoleList);
        } else {
        }
      })
      .catch(() => toast.error("Something went wrong."))
      .finally(
        () => {},
        //setLoading(false)
      );
  };

  const GetAccessControlList = (userid) => {
    UserService.GetAccessControlMasterList(userid, null)
      .then((data) => {
        //debugger;
        if (data.data.IsSuccess) {
          setAccessControlList(data.data.Data);
        } else {
          setAccessControlList();
        }
      })
      .catch((error) => {
        toast.error("Something went wrong");
      })
      .finally(() => {});
  };

  const handleShowModal = () => {
    setShowModal(true);
    GetRoleList();
    GetAccessControlList()
  };

  const handleActivateDeActivateOrgLocationMapping = (rec) => {
    UserService.ActivateDeActivateUserAccessTemplate(rec.Id, !rec.IsActive).then(data => {
        if (data.data.IsSuccess) {
          const message = rec.IsActive ? "User access role mapping deactivated Successfully" : "User access role mapping activated Successfully";
          toast.success(message);
          fetchUniversalRoleUserAccessMasterList();
        } else {
          toast.error("Could not update activity status.");
        }
        //console.log("data", data)
      }).catch(error => {
        toast.error("Something went wrong");
      })
  }

  return (
    <>
      <CommonContainer
        heading="User Access Template For Roles"
        buttonText="Add Mapping"
        onButtonClick={handleShowModal}
      >
        <div className="d-flex flex-column flex-lg-row justify-content-between">
          <div className="d-flex flex-column flex-lg-row gap-2 justify-content-between mb-2"></div>

          <div
            className="search-box patient-visit-search-box"
            style={{ position: "relative", width: "320px" }}
          >
            <div>
              <input
                type="text"
                className="form-control"
                placeholder="Search by Role Name, Access Control Name"
                value={searchData}
                onChange={(e) => setSearchData(e.target.value)}
                style={{
                  paddingRight: "35px",
                  borderRadius: "5px",
                  border: "1px solid #ddd",
                }}
              />
              <button
                className="btn custom-sumbitbtn d-flex align-items-center justify-content-center patient-visit-search-box-search-btn"
                style={{
                  padding: "5px",
                  position: "absolute",
                  top: "0",
                  right: "0px",
                  height: "35px",
                  width: "45px",
                  borderTopLeftRadius: "0",
                  borderBottomLeftRadius: "0",
                }}
                disabled={searchLoading}
              >
                <FaSearch />
              </button>
            </div>
          </div>
        </div>

        <div>
          <div className="table-responsive">
            <table className="table table-bordered custom-table">
              <thead>
                <tr>
                  <th style={{ width: "5%" }}>Role Id</th>
                  <th style={{ width: "30%" }}>Role Name</th>
                  <th style={{ width: "13%" }}>Access Control Id</th>
                  <th style={{ width: "25%" }}>Access Control Name</th>
                  <th style={{ width: "10%" }}>Action</th>
                </tr>
              </thead>

              <tbody
                style={{ fontSize: "0.5rem" }}
                className="patient-list-small-font"
              >
                {searchLoading ? (
                  <tr>
                    <td colSpan="11" className="text-center py-3">
                      <div className="flex justify-center items-center gap-2 primary-green">
                        <FaSpinner
                          size={16}
                          color="green"
                          className="fa-spin"
                        />
                      </div>
                    </td>
                  </tr>
                ) : currentRoleUserAccessMappingList?.length === 0 ? (
                  <tr>
                    <td colSpan="11" className="text-center">
                      No Mappings Found
                    </td>
                  </tr>
                ) : (
                  currentRoleUserAccessMappingList.map((rec) => (
                    <tr className="patient-list-row" key={rec.Id}>
                      <td
                        style={{ textAlign: "center", verticalAlign: "middle" }}
                      >
                        {rec?.Role_Id || "-"}
                      </td>

                      <td
                        style={{ textAlign: "center", verticalAlign: "middle" }}
                      >
                        {rec?.Role_Name || "-"}
                      </td>

                      <td
                        style={{ textAlign: "center", verticalAlign: "middle" }}
                      >
                        {rec?.Access_Control_Id || "-"}
                      </td>

                      <td
                        style={{ textAlign: "center", verticalAlign: "middle" }}
                      >
                        {rec?.Access_Control_Name || "-"}
                      </td>

                      <td>
                        {/* {rec?.IsActive ? ( */}
                          <FaTrash
                            title="Deactivate Mapping"
                            color="red"
                            size={16}
                            style={{ cursor: "pointer" }}
                            onClick={() =>
                              handleActivateDeActivateOrgLocationMapping(rec)
                            }
                          />
                        {/* ) : (
                          <FaToggleOff
                            title="Activate Mapping"
                            color="red"
                            size={16}
                            style={{ cursor: "pointer" }}
                            onClick={() =>
                              handleActivateDeActivateOrgLocationMapping(rec)
                            }
                          />
                        )} */}
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>

          {filteredRoleUserAccessMappingList.length > itemsPerPage && (
            <CommonPagination
              pageList={filteredRoleUserAccessMappingList}
              currentPage={currentPage}
              itemsPerPage={itemsPerPage}
              setCurrentPage={setCurrentPage}
            />
          )}
        </div>
      </CommonContainer>

      {showModal && (
        <RoleUserAccessMappingModal
          showModal={showModal}
          fetchUniversalRoleUserAccessMasterList={
            fetchUniversalRoleUserAccessMasterList
          }
          activeRoleList={activeRoleList}
          accessControlList={accessControlList}
          setShowModal={setShowModal}
        />
      )}
    </>
  );
};

export default RoleUserAccessMappingComponent;
